<template>
  <div>
    <!-- Timesheet detail sidebar -->
    <timesheet-detail></timesheet-detail>
    <div
      class="md:w-auto md:mt-0 sm:w-full w-full sm:mt-3 mt-3 search-header"
      v-if="$store.state.uInfo.role != 'U' || main_tab == 1"
    >
      <div class="inline-block mr-2 lg-15 w-auto mb-2 z-999">
        <vs-input
          icon-pack="feather"
          icon="icon-search"
          v-model="search"
          class="w-auto mr-1"
        />
      </div>
      <div class="inline-block mr-2 lg-15 w-auto mb-2 z-999">
        <v-select
          taggable
          class="w-full mr-1 min-150 bg-white"
          label="office_name"
          index="id"
          :options="all_offices"
          v-model="office_id"
          placeholder="Select Office"
        ></v-select>
      </div>
      <div
        class="inline-block mr-0 lg-15 w-auto mb-2 z-999"
        v-if="office_id && office_id != 'all'"
      >
        <v-select
          taggable
          multiple
          class="w-full min-150 bg-white"
          label="department_name"
          index="id"
          :options="all_departments"
          v-model="department_id"
        ></v-select>
      </div>
    </div>

    <vs-tabs
      v-model="main_tab"
      class="activity-tabs border-tabs-set set-hiddden top-54-tab "
    >
      <vs-tab label="Users Timesheet">
        <!-- Oraganization User Timesheet (DAY/WEEK/MONTH) -->
        <!-- Filter -->
        <div
          class="md:w-auto md:mt-0 sm:w-full w-full sm:mt-3 mt-3 search-header d-medium-inline dis-none"
        >
          <div class="inline-block mr-2 lg-15 w-100 mb-2 z-999">
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              v-model="search"
              class="w-auto mr-1"
            />
          </div>
          <div class="inline-block mr-2 lg-15 w-100 mb-2 z-999">
            <v-select
              taggable
              class="w-full mr-1 min-150"
              label="office_name"
              index="id"
              :options="all_offices"
              v-model="office_id"
              placeholder="Select Office"
            ></v-select>
          </div>
          <div
            class="inline-block mr-0 lg-15 w-100 mb-2 z-999"
            v-if="office_id && office_id != 'all'"
          >
            <v-select
              taggable
              multiple
              class="w-full min-150 bg-white"
              label="department_name"
              index="id"
              :options="all_departments"
              v-model="department_id"
            ></v-select>
          </div>
        </div>

        <vx-card class="new-card-common">
          <div class="all-tabs mb-0">
            <div class="con-ul-tabs">
              <div class="common-tabs">
                <div class="one">
                  <div class="datepicker-main">
                    <!-- <div class="dis-flex align-items-center">
                              <label for class="float-right w-auto mr-2 pb-0">Select Date</label>
                              <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                  placeholder="Select Date"
                                  class="float-right calendar-icon-right top-45"
                                  format="dd/MM/yyyy"
                                  v-model="current_date"
                                  @change="dateweek()"
                                  :disabledDates="disabledDates"
                              ></datepicker>
                            </div> -->
                    <!-- Datepicker for day timesheet -->
                    <div
                      class="dis-flex align-items-center"
                      v-show="timesheet_type == 'day'"
                    >
                      <label for class="float-right w-auto mr-2 pb-0"
                        >Date</label
                      >
                      <datepicker
                        :calendar-button="true"
                        calendar-button-icon="fa fa-calendar"
                        placeholder="Select Date"
                        class="float-right calendar-icon-right top-45"
                        :format="format"
                        v-model="day_current_date"
                        :disabledDates="disabledDates"
                      ></datepicker>
                    </div>
                    <!-- Datepicker for week timesheet -->
                    <div
                      class="dis-flex align-items-center flex-wrap justify-center"
                      v-show="timesheet_type == 'week'"
                    >
                      <label for class="float-right w-auto mr-2 pb-0"
                        >Week Date</label
                      >
                      <!-- <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                                    placeholder="Select Week Date"
                                    class="float-right calendar-icon-right top-45"
                                    :format="format"
                                    v-model="week_current_date"
                                    :disabledDates="disabledDates"
                              ></datepicker> -->
                      <!--  -->
                      <div class="d-flex date-wrapper flex-wrap">
                        <div class="d-flex">
                          <button
                            type="button"
                            @click="prevWeek"
                            title="Previous week"
                            aria-pressed="false"
                            class="fc-prev-button nxt-prv-btn fc-button fc-button-primary"
                          >
                          <!-- class="fc-icon fc-icon-chevron-left" -->
                          <chevron-left-icon size="1.5x" class="custom-class icon_display"></chevron-left-icon>  
                          </button>
                          <button
                            type="button"
                            @click="nextWeek"
                            title="Next week"
                            aria-pressed="false"
                            :disabled="next_hide"
                            class="nxt-prv-btn">
                          <chevron-right-icon size="1.5x" class="custom-class icon_display"></chevron-right-icon>
                          </button>
                        </div>
                        <h4 class="fw600 ml-3">
                          {{start_day}} - {{end_day}} {{month}} {{year}}
                        </h4>
                      </div>
                      <!--  -->
                    </div>
                    <!-- Datepicker for month timesheet -->
                    <div
                      class="dis-flex align-items-center"
                      v-show="timesheet_type == 'month'"
                    >
                      <label for class="float-right w-auto mr-2 pb-0"
                        >Month</label
                      >
                      <datepicker
                        :calendar-button="true"
                        calendar-button-icon="fa fa-calendar"
                        placeholder="Select Month"
                        class="float-right calendar-icon-right top-45"
                        format="MMMM"
                        :minimumView="'month'"
                        :maximumView="'month'"
                        v-model="current_month"
                        :disabledDates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>
                </div>
                <div class="two">
                  <span
                    class=""
                    v-bind:class="{ active: timesheet_type == 'day' }"
                    @click.prevent="timesheet_type = 'day'"
                    >Day</span
                  >
                  <span
                    class=""
                    v-bind:class="{ active: timesheet_type == 'week' }"
                    @click.prevent="timesheet_type = 'week'"
                    >Week</span
                  >
                  <span
                    class=""
                    v-bind:class="{ active: timesheet_type == 'month' }"
                    @click.prevent="timesheet_type = 'month'"
                    >Month</span
                  >
                </div>
                <div class="three">
                  <vue-json-to-csv
                    :json-data="getCsvData()"
                    :csv-title="csv_title"
                  >
                    <vs-button class="gradient-btn">
                      <feather-icon
                        icon="DownloadIcon"
                        title="Download CSV"
                        class
                      ></feather-icon>
                    </vs-button>
                  </vue-json-to-csv>
                  <vs-button
                    class="ml-1 gradient-btn"
                    target="_blank"
                    title="Download PDF"
                    @click.prevent="generatePDF()"
                  >
                    <feather-icon icon="FileTextIcon" class></feather-icon>
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
          <!-- day/week/month timesheet component -->
          <div class="w-full mt-5">
            <div v-show="timesheet_type == 'day'">
              <daily-timesheet
                ref="daytime"
                :current_date="day_current_date"
                :search="search"
                :office_id="office_id"
                :department_id="department_id"
                :day_current_date="day_current_date"
              ></daily-timesheet>
            </div>
            <div v-show="timesheet_type == 'week'">
              <weekly-timesheet
                ref="weektime"
                :current_date="week_current_date"
                :search="search"
                :office_id="office_id"
                :department_id="department_id"
                @weekdate="weeklydays"
              ></weekly-timesheet>
            </div>
            <div v-show="timesheet_type == 'month'">
              <monthly-timesheet
                ref="monthtime"
                :current_month="current_month"
                :search="search"
                :office_id="office_id"
                :department_id="department_id"
              ></monthly-timesheet>
            </div>
          </div>
        </vx-card>
        <!-- <vx-card class="old-card-common">
                  <vs-tabs v-model="sub_tab" alignment="center" class="all-tabs set_min_height">
                      <vs-tab label="Day">
                        <daily-timesheet :search="search" :office_id="office_id" :department_id="department_id"></daily-timesheet>
                      </vs-tab>
                      <vs-tab label="Week">
                        <weekly-timesheet :search="search" :office_id="office_id" :department_id="department_id"></weekly-timesheet>
                      </vs-tab>
                      <vs-tab label="Month">
                        <monthly-timesheet :search="search" :office_id="office_id" :department_id="department_id"></monthly-timesheet>
                      </vs-tab>
                  </vs-tabs>
              </vx-card> -->
      </vs-tab>
      <!-- Daily Time Activity -->
      <vs-tab label="Daily Time Activity">
        <user-activity
          :search="search"
          :office_id="office_id"
          :department_id="department_id"
        ></user-activity>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import { EventBus } from "@/mixins/mixin.js";
import vSelect from "vue-select";
import DailyTimesheet from "@/components/user-timesheet/daily-timesheet.vue";
import WeeklyTimesheet from "@/components/user-timesheet/weekly-timesheet.vue";
import MonthlyTimesheet from "@/components/user-timesheet/monthly-timesheet.vue";
import TimesheetDetail from "@/components/user-timesheet/timesheet-detail.vue";
import Datepicker from "vuejs-datepicker";
import UserActivity from "@/components/user-timesheet/activity/index.vue";
import VueJsonToCsv from "vue-json-to-csv";
import { ChevronRightIcon } from 'vue-feather-icons'
import { ChevronLeftIcon } from 'vue-feather-icons'
import moment from "moment";
import consoleBasic from "caniuse-lite/data/features/console-basic";

export default {
  components: {
    vSelect,
    DailyTimesheet,
    WeeklyTimesheet,
    MonthlyTimesheet,
    TimesheetDetail,
    UserActivity,
    Datepicker,
    ChevronRightIcon,
    ChevronLeftIcon,
    "vue-json-to-csv": VueJsonToCsv,
  },
  data() {
    return {
      main_tab: 0,
      sub_tab: 0,
      search: null,
      all_offices: [],
      office_id: null,
      all_departments: [],
      department_id: null,
      timesheet_type: "day",
      start_day:null,
      end_day:null,
      month:null,
      year:null,
      currentDate:null,
      next_hide:true,
      startDate:null,
      endDate:null,
      // day timesheet
      disabledDates: {
        from: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        ), // Disable all dates after specific date
      },
      day_current_date: new Date(),
      week_current_date: new Date(),
      current_month: new Date(),
      format: "dd/MM/yyyy",
    };
  },
  watch: {
    office_id() {
      this.department_id = null;
      this.getDepartments();
    },
  },
  mounted() {
    // this.getDateTimeData();
    // let startDay = moment().startOf('week').format('DD');
    // let endDay = moment().endOf('week').format('DD');
    // console.log('startDay',startDay,'endDay',endDay);
    this.weeklydays();
    this.getOffice();
  },
  computed: {
    csv_title() {
      if (this.timesheet_type == "day") {
        return "DayData";
      }
      if (this.timesheet_type == "week") {
        return "WeekData";
      }
      if (this.timesheet_type == "month") {
        return "MonthData";
      }
    },
  },
  methods: {
    
    //get date and set it to the weekly timesheet
    weeklydays(weekdate){
      this.next_hide = false;
      this.startDate = weekdate[0].fullDate;
      this.endDate = weekdate[6].fullDate;
      let dateofEnd = moment(this.endDate,'DD/MM/YYYY').format('X');
      let cur_date = moment().format("X");
      if(cur_date >= dateofEnd){
        this.next_hide = false;
      }else{
        this.next_hide = true;
      }
      let weekdays = weekdate;
      let parts_of_date = null;
      let day= [];
      weekdays.forEach((week,index)=>{
        parts_of_date = week.fullDate.split("/");
        this.currentDate = new Date(+parts_of_date[2], parts_of_date[1] - 1, +parts_of_date[0]);
        day.push(moment(this.currentDate).format('DD'))
      })
      this.currentDate = moment(this.currentDate).format('DD-MMMM-YYYY');
      // console.log('output',this.currentDate)
      this.start_day = parseInt(day[0]);
      this.end_day = parseInt(day[6]);
      this.month = moment(this.currentDate).format('MMMM')
      this.year = moment(this.currentDate).format('YYYY')
    },
    //next button
    nextWeek(){
      let start_date = this.startDate;
      start_date = moment(start_date,"DD-MM-YYYY").add(1,'w');
      start_date = moment(start_date, ["DD-MM-YYYY"]).format();
      // console.log('start_date',start_date);
      this.week_current_date = start_date;
    },
    //prev button
    prevWeek(){
      let start_date = this.startDate;
      start_date = moment(start_date,"DD-MM-YYYY").subtract(1,'w');
      
      start_date = moment(start_date, ["DD-MM-YYYY"]).format();
      // console.log('start_date',start_date);
      this.week_current_date = start_date;
    },
    getCsvData() {
      if (this.timesheet_type == "day") {
        return this.$refs.daytime ? this.$refs.daytime.csvData : [];
      }
      if (this.timesheet_type == "week") {
        return this.$refs.weektime ? this.$refs.weektime.csvWeekData : [];
      }
      if (this.timesheet_type == "month") {
        return this.$refs.monthtime ? this.$refs.monthtime.csvMonthData : [];
      }
    },
    generatePDF() {
      // console.log(this.timesheet_type);
      if (this.timesheet_type == "day") {
        EventBus.$emit("dayTimesheetPDF");
      }
      if (this.timesheet_type == "week") {
        EventBus.$emit("weekTimesheetPDF");
      }``
      if (this.timesheet_type == "month") {
        EventBus.$emit("monthTimesheetPDF");
      }
    },
    async getOffice() {
      this.$vs.loading({ color: "primary" });
      let url = "office/getAll";
      this.all_offices = await this.axios
        .get(url)
        .then((response) => {
          this.$vs.loading.close();
          let data = response.data.data;
          if (data && data.length) {
            return data;
          }
          return [];
        })
        .catch((e) => {
          this.showError(e);
          return [];
        });
    },
    async getDepartments() {
      this.$vs.loading({ color: "primary" });
      let url = `dept/getAll?office_id=${this.office_id}`;
      this.all_departments = await this.axios
        .get(url)
        .then((response) => {
          this.$vs.loading.close();
          let data = response.data.data;
          if (data && data.length) {
            return data;
          }
          return [];
        })
        .catch((e) => {
          this.showError(e);
          return [];
        });
    },
  },
};
</script>
<style>
.fc-today-button,
.fc-month-button,
.fc-agendaWeek-button,
.fc-agendaDay-button {
  display: none !important;
}
.application-action {
  float: left !important;
}

.time-box {
  background-color: lightgrey;
  width: 100px;
  border: 1px black;
  padding: 5px;
  margin: 2px;
  text-align: center;
  float: left;
}

.vs-table--tbody {
  z-index: 1 !important;
}

.vdp-datepicker {
  z-index: 2;
}

.vdp-datepicker__calendar {
  right: 0;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .datepicker-main {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    } */
.datepicker-main {
  display: flex;
  align-items: center;
  width: auto;
}
.datewrapper {
  display: flex;
}

.datewrapper label {
  float: right;
  text-align: right;
  line-height: 40px;
  padding-right: 10px;
  font-size: 14px !important;
  font-weight: bold;
}

.sidesheet .vs-sidebar {
  max-width: 450px !important;
  z-index: 99999 !important;
}
.total-hours {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  border-radius: 5px;
  margin-bottom: 10px;
}
.vs-table--search {
  margin: 0 !important;
}
.feather-download,
.feather-printer,
.feather-file-text {
  width: 16px;
  height: 16px;
}
.activity-table {
  max-height: 300px;
  overflow-x: auto;
}
.center-col {
  border-left: 1px solid #e7e7e7 !important;
  border-right: 1px solid #e7e7e7 !important;
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.fc-event,
.fc-event-dot {
  background-color: #3aad68;
}
.fc-event .fcc-content {
  padding-left: 3px;
}
.fc-unthemed td.fc-today {
  background: #3f57fe;
  color: #fff;
}
.fc-unthemed td.fc-past {
  background: #ff9000;
}
.fc-toolbar {
  text-align: right;
}
.hide {
  display: none;
}
.activity-table .header-table {
  justify-content: flex-end !important;
}
.status-table {
  margin-top: 58px;
}
</style>

<style lang="scss">
.sidesheet .vs-sidebar--background {
  z-index: 99999 !important;
}

.sidesheet .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.sidesheet .footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.delete-timesheet {
  margin: 16px 0px;
  padding: 0px 20px;
}

.sidesheet .vs-sidebar--items {
  height: 756px;
  overflow-y: scroll;
}
.vs-table .vs-table--thead .td-check {
  width: 1%;
}

.d-flex{
  display: flex !important;
}


.fw600{
  width: 180px;
  font-weight: 600 !important;
  font-size: 14px;
}

.nxt-prv-btn{
  height: 25px;
  width: 30px;
  background: #fff;
  border: 1px solid black;
  color: black;
}

.nxt-prv-btn:hover{
  color: black !important;
}
.vs-tabs-primary {}
.date-wrapper{
  // width: 275px !important;
  align-items: center;
  justify-content: center;
 
  button{
    cursor: pointer;
    &:not(:disabled){
      &:hover{
          color: #535353 !important;
      }
    }
  }
  button:disabled{
    background: #c3c3c3;
    cursor: auto;
    
  }
}
.con-ul-tabs{
 padding: 30px !important;
}
.common-tabs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .one{
    width: 360px;
  }
  .two{
    width: calc(100% - 634px);
  }
}
</style>
